<template>
<div >
  <div class="d-flex pt-3 border-0 align-items-center justify-content-center bg-white paddingSushi" v-on:click="toggleModal" >
    <h3 class="montserrat-700" >{{ $t("message.termsAndConditions") }}</h3>
  </div>

  <terms-and-conditions-modal v-if="showTerm" @close-modal="toggleModal" :isSushi="this.hqDoc && this.hqDoc.IsSushiHub"/>
</div>



</template>

<script>
import TermsAndConditionsModal from "@/components/shop/partials/termsAndConditionsModal";
import {mapGetters} from "vuex";
export default {
  name: "termsAndCondition",
  components: {TermsAndConditionsModal},
  data(){



    return {
      showTerm: false
    }

  },
  methods :{
    toggleModal() {
      this.showTerm = !this.showTerm;

    }
  },

  computed: {

  ...mapGetters(["hqDoc"])
  }
}
</script>

<style scoped>
.paddingSushi {
  padding-right: 0px !important;
  padding-left: 0px !important;
}


</style>
